import { render, staticRenderFns } from "./cashback-notice.vue?vue&type=template&id=230a7a62&scoped=true&lang=pug&"
import script from "./cashback-notice.vue?vue&type=script&lang=js&"
export * from "./cashback-notice.vue?vue&type=script&lang=js&"
import style0 from "./cashback-notice.vue?vue&type=style&index=0&id=230a7a62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a7a62",
  null
  
)

export default component.exports